import React from 'react';
import SimpleInput from '../form/SimpleInput';
import MoneyInput from '../form/MoneyInput';
import { taxRate } from '../../const';
import { maskMoney } from '../../masks';
import { calcTax } from '../../helpers/util';
import { getOverrideClass } from '../../helpers/autofillOverride';
import { isOccasion } from '../../helpers/serviceUtil';

class ServiceCharge extends React.Component {
  state = {
    isEdit: false,
  };

  render() {
    const { canEdit = true } = this.props;
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Service Charge</h3>
          </div>
          {canEdit && (
            <div className="cms__bar-right">
              {this.renderEditButton()}
              {this.renderSaveButton()}
            </div>
          )}
        </div>
        <div className="cms__section-body">{this.renderBody()}</div>
      </div>
    );
  }

  overrideClass = (fieldName) => this.props.showOverrides ? getOverrideClass(this.props.service, fieldName) : ''

  renderBody = () => {
    const { showTotal = false } = this.props;
    const {
      fee_cents,
      tax_cents,
      est_grocery_cents,
      travel_cents,
      additional_expense_cents,
      promo_code,
      service_charge_notes,
      actual_grocery_cents,
      tip_cents,
    } = this.props.service;

    const total = showTotal ? this.calcTotal() : 0;

    if (this.state.isEdit)
      return (
        <div className="form">
          <div className="form__row">
            <label className="p p--bold" htmlFor="fee_cents">
              Fee
            </label>
            <MoneyInput
              className="simple-input"
              type="text"
              name="fee_cents"
              valueCents={fee_cents || 0}
              onChange={(val) => this.handleChange(val, "fee_cents")}
            />
          </div>
          <div className="form__row">
            <p className="p p--bold">Tax</p>
            <MoneyInput
              className="simple-input"
              type="text"
              disabled={true}
              name="tax_cents"
              valueCents={tax_cents || 0}
              onChange={(val) => this.handleChange(val, "tax_cents")}
            />
          </div>
          <div className="form__row">
            <label className="p p--bold" htmlFor="est_grocery_cents">
              Estimated Grocery Cost
            </label>
            <MoneyInput
              className="simple-input"
              type="text"
              disabled={true}
              name="est_grocery_cents"
              valueCents={est_grocery_cents || 0}
              onChange={(val) => this.handleChange(val, "est_grocery_cents")}
            />
          </div>
          <div className="form__row">
            <label className="p p--bold" htmlFor="tip_cents">
              Tip
            </label>
            <MoneyInput
              className="simple-input"
              type="text"
              name="tip_cents"
              valueCents={tip_cents || 0}
              onChange={(val) => this.handleChange(val, "tip_cents")}
            />
          </div>
          <div className="form__row">
            <label className="p p--bold" htmlFor="actual_grocery_cents">
              Actual Grocery Cost
            </label>
            <MoneyInput
              className="simple-input"
              type="text"
              name="actual_grocery_cents"
              valueCents={actual_grocery_cents || 0}
              onChange={(val) => this.handleChange(val, "actual_grocery_cents")}
            />
          </div>
          <div className="form__row">
            <label className="p p--bold" htmlFor="travel_cents">
              Travel
            </label>
            <MoneyInput
              className="simple-input"
              type="text"
              name="travel_cents"
              valueCents={travel_cents || 0}
              onChange={(val) => this.handleChange(val, "travel_cents")}
            />
          </div>
          <div className="form__row">
            <label className="p p--bold" htmlFor="additional_expense_cents">
              Additional Expenses
            </label>
            <MoneyInput
              className="simple-input"
              type="text"
              name="additional_expense_cents"
              valueCents={additional_expense_cents || 0}
              onChange={(val) => this.handleChange(val, "additional_expense_cents")}
            />
          </div>
          <div className="form__row">
            <label className="p p--bold" htmlFor="promo_code">
              Code
            </label>
            <SimpleInput
              className="simple-input"
              type="text"
              name="promo_code"
              value={promo_code || ''}
              onChange={(e) => { this.handleChange(e.target.value, e.target.name) }}
            />
          </div>
          <div className="form__row">
            <label className="p p--bold" htmlFor="service_charge_notes">
              Service Charge Notes
            </label>
            <SimpleInput
              className="simple-input"
              type="text"
              name="service_charge_notes"
              value={service_charge_notes || ''}
              onChange={(e) => { this.handleChange(e.target.value, e.target.name) }}
            />
          </div>
        </div>
      );
    else
      return (
        <div className="form">
          <div className="form__row">
            <p className="p p--bold">Fee</p>
            <p className={`p ${this.overrideClass('fee_cents')}`}>
              {maskMoney(fee_cents || 0)}
            </p>
          </div>
          <div className="form__row">
            <p className="p p--bold">Tax</p>
            <p className="p">{maskMoney(tax_cents || 0)}</p>
          </div>
          <div className="form__row">
            <p className="p p--bold">Estimated Grocery Cost</p>
            <p className="p">{maskMoney(est_grocery_cents || 0)}</p>
          </div>
          <div className="form__row">
            <p className="p p--bold">Tip</p>
            <p className={`p ${this.overrideClass('tip_cents')}`}>
              {maskMoney(tip_cents || 0)}
            </p>
          </div>
          {actual_grocery_cents > 0 && (
            <div className="form__row">
              <p className="p p--bold">Actual Grocery Cost</p>
              <p className="p">{maskMoney(actual_grocery_cents || 0)}</p>
            </div>
          )}
          <div className="form__row">
            <p className="p p--bold">Travel</p>
            <p className={`p ${this.overrideClass('travel_cents')}`}>
              {maskMoney(travel_cents === undefined ? 1500 : travel_cents)}
            </p>
          </div>
          {additional_expense_cents > 0 ? (
            <div className="form__row">
              <p className="p p--bold">Additional Expenses</p>
              <p className="p">{maskMoney(additional_expense_cents || 0)}</p>
            </div>
          ) : (
            ''
          )}
          {promo_code ? (
            <div className="form__row">
              <p className="p p--bold">
                Code
                <span className="p small p--dark-taupe --new-line">
                  The discount will be applied upon final invoice.
                </span>
              </p>
              <p className="p">{promo_code}</p>
            </div>
          ) : (
            ''
          )}
          {service_charge_notes ? (
            <div className="form__row">
              <p className="p p--bold">Service Charge Notes</p>
              <p className="p">{service_charge_notes}</p>
            </div>
          ) : (
            ''
          )}
          {showTotal && (
            <div className="form__row estimated-total">
              <p className="p p--bold">
                Estimated Total
                <span className="p small p--dark-taupe --new-line">
                  Final service cost will be reflected on final invoice.
                </span>
              </p>
              <p className="p">{maskMoney(total)}</p>
            </div>
          )}
        </div>
      );
  };

  renderEditButton = () => {
    if (!this.state.isEdit)
      return (
        <span className="a--blue" onClick={this.openEdit}>
          Edit
        </span>
      );
  };

  renderSaveButton = () => {
    if (this.state.isEdit)
      return (
        <span className="a--blue" onClick={this.closeEdit}>
          Preview
        </span>
      );
  };

  calcTotal = () => {
    const {
      fee_cents = 0,
      tax_cents = 0,
      est_grocery_cents = 0,
      travel_cents = 0,
      additional_expense_cents = 0,
      tip_cents = 0,
    } = this.props.service;

    return [
      fee_cents,
      tax_cents,
      est_grocery_cents,
      travel_cents,
      additional_expense_cents,
      tip_cents,
    ].reduce((s, t) => s + t);
  };

  openEdit = () => {
    this.setState({ isEdit: true });
  };

  closeEdit = () => {
    this.setState({ isEdit: false });
  };

  handleChange = (value, name) => {
    if (isOccasion(this.props.service)) {
      const override_fields = {
        [name]: true,
        ...this.props.service.override_fields,
      };
      this.props.updateService({ override_fields });
    }
    this.props.updateService({ [name]: value });

    // special case, fee change triggers tax calulation
    if (name === 'fee_cents') {
      const tax_cents = calcTax(value, taxRate);
      this.props.updateService({ fee_cents: value, tax_cents });
    }
  };
}

export default ServiceCharge;



// WEBPACK FOOTER //
// ./src/components/service/ServiceCharge.js